<section class="product-detail" data-testId="product-detail">
  <h3 class="title">
    {{ 'productDetail' | translate }}
  </h3>
  <div class="no-product-message" *ngIf="showNotFoundMessage()">
    <span>{{ 'notFoundProductMessage' | translate }}</span>
  </div>
  <div class="product-table table-responsive" [ngClass]="{ 'product-table-margin-top': !currentQuoteData?.imdCode }" *ngIf="showTable()">
    <div class="imd-code">
      <span class="imd-code__text" *ngIf="currentQuoteData?.imdCode" data-testId="imdCode">
        {{ 'imdCode' | translate }}: {{ currentQuoteData.imdCode.intermediaryId }}
      </span>
    </div>
    <table class="table">
      <thead>
        <tr class="title-row">
          <td class="header-col topic-col table-name">
            {{ 'coverage' | translate }}
          </td>
          <td
            *ngFor="let packages of productDetailData.packages; index as packagesIdx"
            class="header-col plan-col no-padding no-select"
            [ngClass]="{ selected: selectedProduct.index === packagesIdx }"
            (click)="changeSelectedProduct(packagesIdx)"
            [id]="packagesIdx"
            data-testId="package"
          >
            <div class="plan-header-card">
              <span class="plan-name">{{ packages.prodName }}</span>
              <span class="plan-price">฿ {{ calculatePrice(packages.prodPrice) | number: '1.2' }}</span>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let coverages of productDetailData.coverages; index as idx"
          class="product-row"
          [ngClass]="{ odd: idx % 2 === 0, even: idx % 2 === 1 }"
        >
          <td class="topic-col" [ngClass]="{ odd: idx % 2 === 0, even: idx % 2 === 1 }">
            {{ currentLang === 'en' ? coverages.coverageDescEn : coverages.coverageDescTh }}
            <i
              *ngIf="hasCoverageDetail(coverages.coverageCode)"
              aria-hidden="true"
              class="fa fa-question-circle"
              containerClass="coverage-tooltip"
              [tooltip]="'coverageTooltip' | translate"
              placement="right"
            ></i>
          </td>
          <td
            *ngFor="let price of coverages.coverageInsured; index as priceIdx"
            class="plan-col no-select"
            (click)="changeSelectedProduct(priceIdx)"
            [ngClass]="{
              selected: selectedProduct.index === priceIdx,
              'sm-size': productDetailData.packages.length === 4,
              'md-size': productDetailData.packages.length === 3,
              'lg-size': productDetailData.packages.length <= 2
            }"
          >
            {{ price ? price : ('notCover' | translate) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
